import { SafeJSON } from './../../shared/safe-json';
import { Parent } from './../juvenile-case-sections/parent';
import { OtherAllegation } from './../juvenile-case-sections/other-allegations';

export class AllegationUndisciplined {
    private json: any;
    private caseIssueId: string;
    private parents: any = [];
    private attorneys: any = [];
    private otherAllegations: any = [];

    constructor(json: any, caseIssueId: string) {
        this.json = json;
        this.caseIssueId = caseIssueId;
        this.populateParents();
        this.populateAttorneys();
        this.populateOtherAllegations();
    }

    populateAttorneys() {
        let attoerneysArr: any = [];
        let selectedAttorneys: any = SafeJSON.get('selectedAttorneys', this.json);
        let attorneys: any = SafeJSON.get('attorneys', this.json);

        for (const attorneyId of selectedAttorneys) {
            attoerneysArr.push(attorneyId);
        }

        if (attoerneysArr.length > 0) {
            for (const attorneyId of attoerneysArr) {
                for (const attorneyObj of attorneys) {
                    let tempId: string = SafeJSON.get('primaryKey', attorneyObj);
                    if (tempId === attorneyId) {
                        let name: string = SafeJSON.get('attorneyName', attorneyObj);
                        this.attorneys.push(name);
                    }
                }
            }
        }
        this.attorneys.sort();
    }

    populateParents() {
        let obj: any = SafeJSON.get('partyDisplayBean', this.json);
        let index = '0';
        for (const party of obj) {
            let value = new Parent(party, index);
            this.parents.push(value);
        }
    }

    populateOtherAllegations() {
        let obj: any = SafeJSON.get('allegations', this.json);
        for (const otherAllegation of obj) {
            let allegationId: string = SafeJSON.get('allegationId', otherAllegation);
            if (allegationId !== this.caseIssueId) {
                let value = new OtherAllegation(otherAllegation);
                this.otherAllegations.push(value);
            }
        }
    }


    getOtherAllegations(): any[] {
        return this.otherAllegations;
    }

    getParents(): any[] {
        this.parents.sort(function (parent1, parent2) {
            return parent1.getPartyName() === parent2.getPartyName() ? 0 : parent1.getPartyName() < parent2.getPartyName() ? -1 : 1;
        });
        return this.parents;
    }

    getAttorneys(): any[] {
        return this.attorneys;
    }

    /* Adjudication Undisciplined */
    getAdjudicationDate(): string {
        return SafeJSON.get('jaaAdjudicationDate', this.json);
    }

    getAdjudicationEoDate(): string {
        return SafeJSON.get('adjudicationBean.jaaAdjEoDate', this.json);
    }

    getAttorneyName(): string {
        return SafeJSON.get('attorneys.attorneyName', this.json);
    }

    getProvenInd(): string {
        return SafeJSON.get('provenInd', this.json);
    }

    getFactsNotes(): string {
        return SafeJSON.get('factsNotes', this.json);
    }

    getCourtJurisdictionInd(): string {
        return SafeJSON.get('courtJurisdictionInd', this.json);
    }

    getOrderedInd(): string {
        return SafeJSON.get('orderedInd', this.json);
    }

    getTransCounty(): string {
        return SafeJSON.get('transCounty', this.json);
    }

    getContinuedDate(): string {
        return SafeJSON.get('continuedDate', this.json);
    }

    getConditionsInd(): string {
        return SafeJSON.get('conditionsInd', this.json);
    }

    getOrdersNotes(): string {
        return SafeJSON.get('ordersNotes', this.json);
    }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/juvenile/juvenile-case-sections/allegation-undisciplined.ts